import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  _idCentroCosto: Yup.string().required(),
  _idChofer: Yup.string().required(),
  _idServicio: Yup.string().required(),
  _idTecnico: Yup.string().required(),
  estado: Yup.string().required(),
  fechaIngreso: Yup.string().required(),
  fechaSalida: Yup.string().required(),
  titulo: Yup.string().required(),
  tipoPreventivoCorrectivo: Yup.string().required(),
  horas: Yup.number().notRequired(),
  monto: Yup.number().notRequired()
})
